import classNames from 'classnames';
import { ComponentProps } from 'react';

import CleanButton from '../../../../../components/CleanButton/CleanButton';
import borderRadiusAsClasses from '../../../../../shared/borderRadiusAsClasses';

import styles from './TintOnHoverButton.module.css';

type TintOnHoverButtonProps = ComponentProps<typeof CleanButton> & {
    hovering?: boolean;
    fakeButton?: boolean;
    borderRadiusSize?: 'regular' | 'large';
    borderRadius?: 'all' | 'top' | 'bottom' | 'none' | 'left' | 'right';
};

const TintOnHoverButton = ({
    className,
    fakeButton,
    hovering,
    children,
    borderRadius = 'none',
    borderRadiusSize = 'regular',
    disabled,
    ...props
}: TintOnHoverButtonProps) => {
    const classes = classNames(className, styles.Root, {
        [styles.hovering]: hovering,
        [borderRadiusAsClasses(borderRadius, { size: borderRadiusSize })]: true,
        [styles.disabled]: disabled,
    });

    if (fakeButton) {
        return <span className={classes}>{children}</span>;
    }

    return (
        <CleanButton {...props} className={classes} disabled={disabled}>
            {children}
        </CleanButton>
    );
};

export default TintOnHoverButton;
